import './styles/@theme';

export const Breadcrumbs = ({
    linkLabel = '',
    hasCategoryV2Layout = false
}: {
    linkLabel: string;
    hasCategoryV2Layout: boolean;
}) => {
    return (
        <nav className="breadcrumbs">
            {!hasCategoryV2Layout && (
                <>
                    <a href="/">Casino</a>
                    <span className="separator"> / </span>
                </>
            )}
            <h1>{linkLabel}</h1>
        </nav>
    );
};
